// import Vue from 'vue';
import axiosFactory from 'axios';

export const baseApiUrl = process.env.VUE_APP_URL || (location.origin + '/');

const instance = axiosFactory.create({
  baseURL: baseApiUrl,
});

const defaultOptions = () => {
  return {
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${localStorage.getItem('token')}`,
    },
    withCredentials: true,
  }
};

// var handleAuthError = error => {
//   if (error.response.status === 401) {
//     Vue.prototype.$notify({ type: 'error', message: error.response.data.message || error.response.data.error.message || 'Error' });
//     Vue.prototype.$store.state.token = null;
//   } else if (error.response.status === 403) {
//     Vue.prototype.$confirm('You don\'t have permission to view this page', '', 'Ok', '', true)
//   } else return Promise.reject(error);
// }
// instance.interceptors.response.use(f => f, handleAuthError);

var axios = {
  get: (url, options) => instance.get(url, { ...defaultOptions(), ...(options || {}) }),
  post: (url, data, options) => instance.post(url, data, { ...defaultOptions(), ...(options || {}) }),
  patch: (url, data, options) => instance.patch(url, data, { ...defaultOptions(), ...(options || {}) }),
  put: (url, data, options) => instance.put(url, data, { ...defaultOptions(), ...(options || {}) }),
  delete: (url, options) => instance.delete(url, { ...defaultOptions(), ...(options || {}) }),
  head: (url, options) => instance.head(url, { ...defaultOptions(), ...(options || {}) }),
  options: (url, options) => instance.options(url, { ...defaultOptions(), ...(options || {}) }),
  isCancel: axiosFactory.isCancel,
  CancelToken: axiosFactory.CancelToken,
};

if (process.env.NODE_ENV === 'development') window['thisAxios'] = axios;

if (window['axios'])
  axios = window['axios'];

export default axios;
